import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuthStore } from '../store/authStore';
import toast from 'react-hot-toast';

export default function Login() {
  const navigate = useNavigate();

  const { login, verify2FA, isLoading, erro } = useAuthStore();

  const [formData, setFormData] = useState({
    email: '',
    senha: '',
  });

  const [show2FA, setShow2FA] = useState(false);
  const [codigo2FA, setCodigo2FA] = useState('');

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {

      const response = await login(formData.email, formData.senha);

      if (response?.requires2Fa) {

        setShow2FA(true);
        toast.success('Insira o código do seu aplicativo autenticador');
      } else {

        toast.success('Login realizado com sucesso!');
        navigate('/dashboard');
      }
    } catch (error) {
      toast.error(typeof erro === 'string' ? erro : 'Erro ao fazer login');
    }
  };

  const handleVerify2FA = async (e) => {
    e.preventDefault();
    try {
      await verify2FA(codigo2FA);
      toast.success('Login realizado com sucesso!');
      navigate('/dashboard');
    } catch (error) {
      toast.error(typeof erro === 'string' ? erro : 'Código 2FA inválido');
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50">

      <div className="w-full max-w-md bg-white border border-slate-200 rounded-lg shadow-sm p-8 sm:p-10">

        <div className="text-center mb-10">
          <div className="h-20 w-20 mx-auto flex items-center justify-center mb-4 overflow-hidden rounded-xl">
            <img 
              src="/logo-cacintex.jpeg" 
              alt="Cacintex Logo" 
              className="w-full h-full object-cover"
            />
          </div>
          <h1 className="text-2xl font-semibold text-slate-900">
            Cacintex
          </h1>
          <p className="text-slate-500 mt-1 text-sm">
            Gestão de Importações
          </p>
        </div>

        {}
        {!show2FA ? (
          <form onSubmit={handleSubmit} className="space-y-6 transition-all duration-500">
            <div className="space-y-1.5">
              <label htmlFor="email" className="block text-sm font-medium text-slate-700">
                E-mail de Acesso
              </label>
              <input
                id="email"
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="nome@empresa.com"
                className="w-full px-4 py-2.5 bg-white border border-slate-300 rounded-md shadow-sm focus:ring-2 focus:ring-slate-900 focus:border-slate-900 transition-colors outline-none text-slate-800 placeholder-slate-400"
                required
              />
            </div>

            <div className="space-y-1.5">
              <label htmlFor="senha" className="block text-sm font-medium text-slate-700">
                Senha
              </label>
              <input
                id="senha"
                type="password"
                name="senha"
                value={formData.senha}
                onChange={handleChange}
                placeholder="••••••••"
                className="w-full px-4 py-2.5 bg-white border border-slate-300 rounded-md shadow-sm focus:ring-2 focus:ring-slate-900 focus:border-slate-900 transition-colors outline-none text-slate-800 placeholder-slate-400"
                required
              />
            </div>

            {erro && !show2FA && (
              <div className="bg-red-50 border-l-4 border-red-500 text-red-700 px-4 py-3 rounded-r-md text-sm font-medium">
                {erro}
              </div>
            )}

            <button
              type="submit"
              disabled={isLoading}
              className="w-full bg-slate-900 hover:bg-slate-800 text-white font-medium py-3 px-4 rounded-md shadow-sm transition-colors disabled:opacity-50 disabled:cursor-not-allowed flex justify-center items-center gap-2 mt-4"
            >
              {isLoading ? (
                <>
                  <svg className="animate-spin h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                  </svg>
                  <span>Autenticando...</span>
                </>
              ) : (
                'Entrar na Plataforma'
              )}
            </button>
          </form>
        ) : (
          <form onSubmit={handleVerify2FA} className="space-y-6 transition-all duration-500 translate-x-0">
            <div className="text-center">
              <div className="inline-flex items-center justify-center w-14 h-14 rounded-full bg-slate-100 text-slate-700 mb-5">
                <svg className="w-7 h-7" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"></path>
                </svg>
              </div>
              <p className="text-sm text-slate-500 px-4 leading-relaxed">
                Plataforma Protegida. Digite o código de 6 dígitos gerado pelo seu Authenticator.
              </p>
            </div>

            <div className="space-y-2 pt-2">
              <input
                id="codigo2FA"
                type="text"
                maxLength="6"
                value={codigo2FA}
                onChange={(e) => setCodigo2FA(e.target.value.replace(/\D/g, ''))}
                placeholder="000 000"
                className="w-full px-4 py-4 text-center text-4xl font-bold tracking-[0.3em] text-slate-900 bg-white border border-slate-300 rounded-md shadow-sm focus:ring-2 focus:ring-slate-900 focus:border-slate-900 transition-colors outline-none placeholder-slate-300"
                required
              />
            </div>

            {erro && show2FA && (
              <div className="bg-red-50 border-l-4 border-red-500 text-red-700 px-4 py-3 rounded-r-md text-sm font-medium">
                {erro}
              </div>
            )}

            <div className="space-y-3 pt-4">
              <button
                type="submit"
                disabled={isLoading || codigo2FA.length !== 6}
                className="w-full bg-slate-900 hover:bg-slate-800 text-white font-medium py-3 px-4 rounded-md shadow-sm transition-colors disabled:opacity-50 disabled:cursor-not-allowed flex justify-center items-center gap-2"
              >
                {isLoading ? 'Checando Segurança...' : 'Validar Acesso'}
              </button>

              <button
                type="button"
                onClick={() => setShow2FA(false)}
                className="w-full bg-transparent hover:bg-slate-50 text-slate-500 hover:text-slate-700 font-medium py-3 px-4 rounded-md transition-colors"
              >
                Cancelar
              </button>
            </div>
          </form>
        )}
      </div>
    </div>
  );
}